import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgZorroModule } from "src/app/ng-zorro.module";
import { FabComponent } from "./fab.component";

@NgModule({
  declarations: [FabComponent],
  imports: [CommonModule, NgZorroModule],
  exports: [FabComponent],
})
export class FabModule {}
